import { InjectionToken, Injector } from "@angular/core";
import { ValueProvider } from "./common/ValueProvider";

let _injector: Injector;

export const setInjector = (injector: Injector) => _injector = injector;
export const getInjector = () => _injector;
export const VALUE_PROVIDER = new InjectionToken<ValueProvider<any>>('VALUE_PROVIDER');